import * as React from 'react'
import ReactModal from 'react-modal'
import styled, { createGlobalStyle } from 'styled-components'
import isomorphicCookie from 'isomorphic-cookie'

import ActionButton from '../../ui/ActionButton/ActionButton'
import media from '../../../services/generateMediaQueries'
import PrivacyModalLink from '../PrivacyModalLink/PrivacyModalLink'

const ModalStyle = createGlobalStyle`
  .policy-modal {
    position: fixed;
    background: transparent;
    top: unset;
    left: unset;
    bottom: 0px;
    right: 0px;
    margin: 1rem;
    width: 100%;
    max-width: 400px;
    height: 190px;
    z-index: 9999;

    ${media.lessThan('small')`
      margin: 0;
      max-width: unset;
    `}
  }
`

const StyledModal = styled(ReactModal)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #ffffff;

  width: 100%;
  height: 100%;

  border-radius: 10px;

  outline: none;

  padding: 2rem;

  box-shadow: var(--box-shadow-medium);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    border-radius: 0;
    box-shadow: var(--box-shadow-medium-top);
  `}
`

const Text = styled.p`
  margin: 0;
  margin-bottom: 1rem;

  > a {
    text-decoration: none;
  }
`

const StyledButton = styled(ActionButton)`
  height: 2.5rem;
  font-size: 0.75rem;
  padding: 0 1.5rem;
`

const content = {}

function CookiePolicyModal() {
  const isCookiePolicyAccepted =
    isomorphicCookie.load('cookiePolicyAccepted', {
      secure: process.env.NODE_ENV === 'production',
    }) || false
  const [modalState, setModalState] = React.useState(!isCookiePolicyAccepted)

  const onContinueClick = () => {
    isomorphicCookie.save('cookiePolicyAccepted', true, {
      secure: process.env.NODE_ENV === 'production',
    })

    setModalState(!modalState)
  }

  return (
    <>
      <StyledModal
        isOpen={!isCookiePolicyAccepted}
        style={{
          // overlay,
          content,
        }}
        closeTimeoutMS={150}
        overlayClassName="policy-modal"
      >
        <Text>
          This site uses cookies to provide you with a great user experience. By
          visiting Ayala Malls, you accept our{' '}
          <PrivacyModalLink isAyalaPN href="#">
            use of cookies.
          </PrivacyModalLink>
        </Text>
        <StyledButton variant="primary" onClick={onContinueClick}>
          Continue
        </StyledButton>
      </StyledModal>
      <ModalStyle />
    </>
  )
}

CookiePolicyModal.defaultProps = {
  // TODO: specify default props
}

CookiePolicyModal.propTypes = {
  // TODO: specify prop types
}

export default CookiePolicyModal
